import { directoryTypes } from './directoryTypes';

export default function areFoldersSupported(directoryType) {
	switch (directoryType) {
	case directoryTypes.employee:
	case directoryTypes.employeeInactive:
	case directoryTypes.employeePending:
	case directoryTypes.employeeTracked:
	case directoryTypes.slideshow:
	case directoryTypes.tv:
	case directoryTypes.reportPinned:
	case directoryTypes.reportScheduled:
	case directoryTypes.reportDisabled:
	case directoryTypes.achievement:
	case directoryTypes.contest:
	case directoryTypes.contestFinished:
		return false;
	default:
		return true;
	}
}
